import React from 'react';
// import { useDispatch } from 'react-redux';

// import { getSubscriptionsList } from 'src/store/app';

import {
  Comparison,
  Faq,
  Features,
  Footer,
  Hero,
  ParticipatingStreamers,
  Pricing
} from './components';

import './landing.scss';

export const Landing = () => {
  // const dispatch = useDispatch();

  // useEffect(() => {
  //   dispatch(getSubscriptionsList());
  // }, [dispatch]);

  return (
    <div className="landing">
      <Hero />
      <ParticipatingStreamers />
      <Features />
      <Comparison />
      <Pricing />
      <Faq />
      <Footer />
    </div>
  );
};
